// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ca1f6de","337":"29dfe1d1","453":"93e411c3","667":"9f6c0070"}[chunkId] + ".chunk.js";
};